import Popover from 'components/Popover';
import { useSiteSwitcher } from 'components/SiteSwitcher';
import { useGlobalMemberPopoversContext } from 'contexts';
import { useIsCompanySite } from 'hooks';
import { useI18n } from 'utils/i18n';

import LoginOptions from './LoginOptions';

/** Login popover panel. */
export default function Login() {
	const isCompanySite = useIsCompanySite();
	const { switchSite } = useSiteSwitcher();
	const { closeLogin, isLoginOpen, openSignUp } =
		useGlobalMemberPopoversContext();

	const { t } = useI18n();

	const id = 'page-header-login';
	const popoverHeaderId = `popover-${id}-title`;

	return (
		<Popover
			isOpen={isLoginOpen}
			title={t('general_login_button_text')}
			id={`popover-${id}`}
			titleId={popoverHeaderId}
			onClose={() => {
				closeLogin();
			}}
			contentClassName="flex flex-col"
		>
			<LoginOptions
				introText={
					isCompanySite
						? t('account_pro_login_intro_text')
						: t('account_club_login_intro_text')
				}
				becomeMemberButtonText={
					isCompanySite
						? t('account_julapro_become_member_button')
						: t('account_julaclub_become_member_button')
				}
				onBecomeMemberClick={() => {
					openSignUp();
					closeLogin();
				}}
				onSwitchSiteClick={switchSite}
				switchSiteButtonText={
					isCompanySite
						? t('account_login_switch_to_private')
						: t('account_login_switch_to_company')
				}
			/>
		</Popover>
	);
}
Login.displayName = 'Login';
